import { ArrowLeft, Newspaper, SearchX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { localizePath } from "@/lib/localeRoutes";

const NotFound = () => {
  const { t, i18n } = useTranslation("errors");
  const homePath = localizePath("/", i18n.language);
  const articlesPath = localizePath("/articles", i18n.language);

  return (
    <>
      <SEOHead
        title={t("404.seoTitle")}
        description={t("404.seoDescription")}
        noIndex
      />
      <main className="relative isolate flex min-h-[70vh] items-center overflow-hidden bg-gradient-to-br from-background via-accent/40 to-secondary/20 px-4 py-24">
        <div
          aria-hidden="true"
          className="absolute left-1/2 top-0 -z-10 h-80 w-80 -translate-x-1/2 rounded-full bg-primary/10 blur-3xl"
        />
        <div className="mx-auto max-w-2xl text-center">
          <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-3xl border border-primary/15 bg-background/80 shadow-sm backdrop-blur">
            <SearchX className="h-9 w-9 text-primary" aria-hidden="true" />
          </div>
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary">
            {t("404.eyebrow")}
          </p>
          <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-6xl">
            {t("404.message")}
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-muted-foreground">
            {t("404.description")}
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to={homePath}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-md bg-primary px-6 py-3 font-semibold text-primary-foreground shadow-sm transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
              {t("404.returnHome")}
            </Link>
            <Link
              to={articlesPath}
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-md border border-border bg-background px-6 py-3 font-semibold text-foreground shadow-sm transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              <Newspaper className="h-4 w-4" aria-hidden="true" />
              {t("404.exploreArticles")}
            </Link>
          </div>
        </div>
      </main>
    </>
  );
};

export default NotFound;
